module.exports = __webpack_public_path__ + "static/media/extend_work_request.7d2b8c24.svg";